<template>
  <div style="width: 90vw">
    <el-container class="contain-6" style="padding: 25px 25px">


      <div class="bbb">

        <el-drawer
            title="分类设置"

            :visible.sync="dialog"
            direction="ltr"
            custom-class="demo-drawer"
            ref="drawer"
        >
          <div class="demo-drawer__content">
            <el-form :model="form" style="margin-left: 50px;">
              <el-form-item label="游戏名称:" :label-width="formLabelWidth">
                <el-select v-model="form.gameName" placeholder="游戏选择"
                           style="width: 280px"
                           filterable clearable allow-create>
                  <el-option
                      v-for="item in optionsGame"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="类别:" :label-width="formLabelWidth">
                <el-select v-model="form.gameType" placeholder="类别选择"
                           style="width: 280px"
                           filterable clearable allow-create>
                  <el-option
                      v-for="item in uniqueGameTypes"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="30天内比例:" :label-width="formLabelWidth">
              <el-input-number v-model="form.gameXi1" ></el-input-number>
              </el-form-item>
              <el-form-item label="30天以后比例:" :label-width="formLabelWidth">
                <el-input-number v-model="form.gameXi2"></el-input-number>
              </el-form-item>
            </el-form>
            <div class="demo-drawer__footer">
              <el-button style="margin-left: 100px" @click="cancelForm">取 消</el-button>
              <el-button type="primary" @click="add" :loading="loading">
                {{ loading ? '提交中 ...' : '确 定' }}
              </el-button>
            </div>
          </div>
        </el-drawer>
        <el-header style="display: flex;height: 40px;">


          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="search" icon="el-icon-refresh">
            刷新
          </el-button>

          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="dialog = true" icon="el-icon-folder-add">
            增加
          </el-button>


        </el-header>
        <el-table
            ref="tableData1"
            :data="tableData"
            stripe
            max-height="80vh"
            height="79vh"
            style="margin-top: 11px"
            :header-cell-style="{background:'rgb(244,244,245)',color:'#323335'}"
            size="mini"
            v-loading="loading"
            highlight-current-row

        >
          <el-table-column
              prop="gameName"
              label="游戏名"
              min-width="160"
          >

          </el-table-column>
          <el-table-column
              prop="gameType"
              label="类别"
              min-width="160"
          >

          </el-table-column>
          <el-table-column
              prop="gameXi1"
              label="30天内系数"
              min-width="160"
          >

          </el-table-column>
          <el-table-column
              prop="gameXi2"
              label="30天以后系数"
              min-width="160"
          >

          </el-table-column>

          <el-table-column
              prop="bfUv"
              label="操作"
              min-width="160"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row)" size="small">编辑</el-button>
              <el-button type="text" style="color: #d65055" @click="del(scope.row)" size="small">删除</el-button>

            </template>
          </el-table-column>
        </el-table>


      </div>


    </el-container>

  </div>
</template>
<script>
export default {
  name: "ProjectBroad",

  data() {

    return {
      tableData: [],
      currentPage: 1,
      fl: false,
      loading: false,
      registerDate: "",
      type: 'pv',
      valueUser: "",
      avgEcpm: 0,
      valueGame: "",
      dialog: false,

      form: {
        id: null,
        gameName: '',
        gameType: '',
        gameXi1:0,
        gameXi2:0

      },
      person: '',
      formLabelWidth: '120px',
      timer: null,
      optionsGame: []

    }


  }, computed: {
    uniqueGameTypes() {
      // 从 tableData 中提取唯一的 gameType 值
      const gameTypes = this.tableData
          .map(item => item.gameType)
          .filter(type => type !== undefined && type !== null && type !== '');

      // 使用 Set 去重
      return [...new Set(gameTypes)];
    }
  },
  watch: {}, filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return value == '' ? '-' : value

      } else if (value < 100) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }
  }, methods: {
    del(row) {

      this.$axios
          .get('/toufangWx/data/gameConfig/del/' + row.id, {})
          .then(successResponse => {
            this.search()
          })

    },


    indexMethod(index) {

      return index / 6 + 1;

    }, cancelForm() {
      // 重置表单
      this.form = {
        id: null,
        gameName: '',
        gameType: '',
        gameXi1:0,
        gameXi2:0
      };
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
      // warning-row
    }, objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },
    addProp() {

      this.newPropValue = ''

      if (!this.arr1.includes(this.valProp))
        this.arr1.push(this.valProp + '_')

      if (this.valProp2 != '') {

        this.arr1.push(this.valProp2)
      }
      if (this.valueSuan != '') {

        this.arr2.push(this.valueSuan)

      }


      for (let i = 0; i < this.arr1.length; i++) {
        console.log(this.arr1[i]);

        this.newPropValue = this.newPropValue + this.arr1[i]

        if (this.arr2.length > i)
          this.newPropValue = this.newPropValue + this.arr2[i]

      }


    },
    date_format_new() {

      let date1 = new Date();

      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '' + month + '' + day;


    },
    createExportData() {

      console.log("下载", this.value1)

      for (let j = 0; j < this.titleHeads.length; j++) {


        this.json_fields[this.titleHeads[j].sta_view_value] = this.titleHeads[j].sta_value
      }


      this.json_data = this.tableData


      return this.json_data

    },


    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    },
    value_format(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0 || isNaN(value)) {

        return "-"
      } else {
        value = Math.round(value / 100)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return value == '' ? '-' : value

      } else if (value < 5) {

        return value.toFixed(2)

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, edit(row) {

      console.log(row)
      this.dialog = true
      this.form = row

    },
    add() {


      this.$axios
          .post('/toufangSp/data/gameConfig/add', this.form)
          .then(successResponse => {

            this.search()

          }).catch((err) => {
        //请求失败的回调函数
        console.log(err)
        console.log('失败')
      })
      // 重置表单
      this.form = {
        id: null,
        gameName: '',
        gameType: ''
      };

      this.dialogFormVisible = false

    }, findGame() {

      this.$axios
          .get('/toufangSp/data/findName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    },
    search() {

      this.loading = true

      this.$axios
          .post('/toufangWx/data/gameConfig/find', {})
          .then(successResponse => {


            var b = successResponse.data.data

            this.tableData = b


            this.loading = false
          }).catch((err) => {
        //请求失败的回调函数
        console.log(err)
        console.log('失败')
      })


    },

  }
  , updated() {

    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })

  },
  mounted: function () {
    this.height = window.innerHeight;
    // this.date_format_new()
    this.findGame()
    this.search()

  }


}
</script>
<style>
.inputA {

  width: 220px;

}

</style>
<style type="text/css">

*::-webkit-scrollbar {
  width: 5px;
  height: 12px;
  background-color: transparent;
}

/* 修改el-table__body-wrapper样式的层级--fixed滚动条无法滚动 */
.el-table__fixed,
.el-table__fixed-right {
  pointer-events: none;
  /* 解决因为滚动条无法滚动导致无法勾选和全选的问题 */

  td {
    pointer-events: auto;
  }

  th {
    pointer-events: auto;
  }
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
*::-webkit-scrollbar-track {
  background-color: #f0f6ff;
}

/*定义滚动条轨道 内阴影+圆角*/
*::-webkit-scrollbar-thumb {
  background-color: #b1b2b3;

}

/*定义滑块 内阴影+圆角*/
.scrollbarHide::-webkit-scrollbar {
  display: none
}

.scrollbarShow::-webkit-scrollbar {
  display: block
}

.bbb {
  //box-shadow: rgba(148,148,148,0.34) 0px 1px 3px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  border-radius: 8px;
  background-color: #FFFFFF;
  width: 98%;
  //margin-left: 2%;

  min-height: 80vh;
}

</style>


<style scoped>

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.94);

}

/deep/ .el-range-input {
  background-color: rgba(240, 240, 240, 0.94);

}
</style>